import { SelectPicker } from '../custom-packages/choicesjs/selectPicker';

export enum AccountStatus {
    InReview = 0,
    Approved = 1,
    BlockedByAdmin = 2,
}

export function getAccountStatusString(status: AccountStatus): string {
    switch (status) {
        case AccountStatus.InReview:
            return 'In behandeling';
        case AccountStatus.Approved:
            return 'Actief';
        case AccountStatus.BlockedByAdmin:
            return 'Geblokkeerd';
        default:
            return 'Onbekend';
    }
}

export const changeAccountStatusOptions: SelectPicker[] = [
    { value: String(AccountStatus.Approved), label: 'Account activeren' },
    { value: String(AccountStatus.BlockedByAdmin), label: 'Account blokkeren' },
    { value: String(AccountStatus.InReview), label: 'Account in behandeling zetten' },
];
